import { countLogs, countThreats, countEmailLogs, getAllImports, getAllThreats, getAllLogs, getAllIpEnrichments, getLoginStatsByUser, getFailedLoginsByIp, getFailedLoginsByAsn } from '../services/storage.js';
import { html, SEVERITY_SORT_ASC } from '../services/util.js';
import './toast-container.js';

const ACTIVITY_DAYS = 14;

const template = document.createElement('template');
template.innerHTML = `
  <div class="section-header">
    <h1>Dashboard</h1>
    <div class="section-actions">
      <button class="btn btn-sm btn-secondary" id="dash-refresh">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>
        Refresh
      </button>
    </div>
  </div>

  <div class="dashboard-stats" id="dash-stats"></div>

  <div class="activity-chart" id="dash-activity"></div>

  <div class="dashboard-panels" id="dash-panels">
    <div class="dashboard-panel" draggable="true" data-panel-id="recent-threats" data-panel-size="half">
      <div class="dashboard-panel-header">
        <span class="dash-grip" title="Drag to reorder">
          <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor"><circle cx="3" cy="2" r="1.5"/><circle cx="7" cy="2" r="1.5"/><circle cx="3" cy="7" r="1.5"/><circle cx="7" cy="7" r="1.5"/><circle cx="3" cy="12" r="1.5"/><circle cx="7" cy="12" r="1.5"/></svg>
        </span>
        <h3>Recent Threats</h3>
        <span class="panel-link" data-pane="threats">View all</span>
      </div>
      <div class="dashboard-panel-body" id="dash-threats-body"></div>
    </div>
    <div class="dashboard-panel" draggable="true" data-panel-id="recent-imports" data-panel-size="half">
      <div class="dashboard-panel-header">
        <span class="dash-grip" title="Drag to reorder">
          <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor"><circle cx="3" cy="2" r="1.5"/><circle cx="7" cy="2" r="1.5"/><circle cx="3" cy="7" r="1.5"/><circle cx="7" cy="7" r="1.5"/><circle cx="3" cy="12" r="1.5"/><circle cx="7" cy="12" r="1.5"/></svg>
        </span>
        <h3>Recent Imports</h3>
        <span class="panel-link" data-pane="imports">View all</span>
      </div>
      <div class="dashboard-panel-body" id="dash-imports-body"></div>
    </div>
    <div class="dashboard-panel" draggable="true" data-panel-id="geo" data-panel-size="full">
      <div class="dashboard-panel-header">
        <span class="dash-grip" title="Drag to reorder">
          <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor"><circle cx="3" cy="2" r="1.5"/><circle cx="7" cy="2" r="1.5"/><circle cx="3" cy="7" r="1.5"/><circle cx="7" cy="7" r="1.5"/><circle cx="3" cy="12" r="1.5"/><circle cx="7" cy="12" r="1.5"/></svg>
        </span>
        <h3>Geographic Coverage</h3>
      </div>
      <div class="dashboard-panel-body" id="dash-geo-body"></div>
    </div>
    <div class="dashboard-panel" draggable="true" data-panel-id="users" data-panel-size="full">
      <div class="dashboard-panel-header">
        <span class="dash-grip" title="Drag to reorder">
          <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor"><circle cx="3" cy="2" r="1.5"/><circle cx="7" cy="2" r="1.5"/><circle cx="3" cy="7" r="1.5"/><circle cx="7" cy="7" r="1.5"/><circle cx="3" cy="12" r="1.5"/><circle cx="7" cy="12" r="1.5"/></svg>
        </span>
        <h3>Most Targeted Users</h3>
      </div>
      <div class="dashboard-panel-body" id="dash-users-body"></div>
    </div>
    <div class="dashboard-panel" draggable="true" data-panel-id="failed-ips" data-panel-size="half">
      <div class="dashboard-panel-header">
        <span class="dash-grip" title="Drag to reorder">
          <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor"><circle cx="3" cy="2" r="1.5"/><circle cx="7" cy="2" r="1.5"/><circle cx="3" cy="7" r="1.5"/><circle cx="7" cy="7" r="1.5"/><circle cx="3" cy="12" r="1.5"/><circle cx="7" cy="12" r="1.5"/></svg>
        </span>
        <h3>Top Failed IPs</h3>
      </div>
      <div class="dashboard-panel-body dashboard-scroll-body" id="dash-failed-ips-body"></div>
    </div>
    <div class="dashboard-panel" draggable="true" data-panel-id="failed-asns" data-panel-size="half">
      <div class="dashboard-panel-header">
        <span class="dash-grip" title="Drag to reorder">
          <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor"><circle cx="3" cy="2" r="1.5"/><circle cx="7" cy="2" r="1.5"/><circle cx="3" cy="7" r="1.5"/><circle cx="7" cy="7" r="1.5"/><circle cx="3" cy="12" r="1.5"/><circle cx="7" cy="12" r="1.5"/></svg>
        </span>
        <h3>Top Failed ASNs</h3>
      </div>
      <div class="dashboard-panel-body dashboard-scroll-body" id="dash-failed-asns-body"></div>
    </div>
  </div>
`;

export class DashboardPane extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = template.innerHTML;
  }

  connectedCallback() {
    this.querySelector('#dash-refresh').addEventListener('click', () => this.refresh());
    this.querySelectorAll('.panel-link').forEach(link => {
      link.addEventListener('click', () => {
        const pane = link.dataset.pane;
        document.dispatchEvent(new CustomEvent('threatscope:switch-pane', { detail: { pane } }));
      });
    });
    document.addEventListener('threatscope:stats-update', () => this.refresh());
    document.addEventListener('threatscope:data-cleared', () => this.refresh());

    // Clean up old grid-level order key
    try { localStorage.removeItem('threatscope:dashboard-grid-order'); } catch (_) { /* ignore */ }
    this._setupDragDrop();
    this._restorePanelOrder();
    this.refresh();
  }

  // ── Drag-and-Drop Panel Reordering ──

  _setupDragDrop() {
    this._dragSrc = null;

    this.querySelectorAll('.dashboard-panel[draggable]').forEach(panel => {
      panel.addEventListener('dragstart', e => this._onDragStart(e));
      panel.addEventListener('dragend', e => this._onDragEnd(e));
      panel.addEventListener('dragover', e => this._onDragOver(e));
      panel.addEventListener('dragleave', e => this._onDragLeave(e));
      panel.addEventListener('drop', e => this._onDrop(e));
    });
  }

  _onDragStart(e) {
    const panel = e.target.closest('.dashboard-panel');
    if (!panel) return;
    this._dragSrc = panel;
    panel.classList.add('dash-dragging');
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', panel.dataset.panelId || 'panel');
  }

  _onDragEnd(e) {
    const panel = e.target.closest('.dashboard-panel') || this._dragSrc;
    if (panel) panel.classList.remove('dash-dragging');
    this.querySelectorAll('.dashboard-panel').forEach(p => p.classList.remove('dash-drag-over'));
    this._dragSrc = null;
  }

  _onDragOver(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    const target = e.target.closest('.dashboard-panel');
    if (!target || target === this._dragSrc) return;
    target.classList.add('dash-drag-over');
  }

  _onDragLeave(e) {
    const target = e.target.closest('.dashboard-panel');
    if (target) target.classList.remove('dash-drag-over');
  }

  _onDrop(e) {
    e.preventDefault();
    const target = e.target.closest('.dashboard-panel');
    if (!target || !this._dragSrc || target === this._dragSrc) return;

    target.classList.remove('dash-drag-over');
    this._dragSrc.classList.remove('dash-dragging');

    // Determine insertion point based on mouse Y relative to target
    const rect = target.getBoundingClientRect();
    const after = e.clientY > rect.top + rect.height / 2;
    const container = this.querySelector('#dash-panels');

    if (after) {
      container.insertBefore(this._dragSrc, target.nextElementSibling);
    } else {
      container.insertBefore(this._dragSrc, target);
    }

    this._savePanelOrder();
    this._dragSrc = null;
  }

  _savePanelOrder() {
    const order = [];
    this.querySelectorAll('.dashboard-panel[data-panel-id]').forEach(panel => {
      order.push(panel.dataset.panelId);
    });
    try {
      localStorage.setItem('threatscope:dashboard-panel-order', JSON.stringify(order));
    } catch (_) { /* localStorage may be unavailable */ }
  }

  _restorePanelOrder() {
    let order;
    try {
      const saved = localStorage.getItem('threatscope:dashboard-panel-order');
      if (saved) order = JSON.parse(saved);
    } catch (_) { /* ignore */ }
    if (!order || !Array.isArray(order)) return;

    const panels = {};
    this.querySelectorAll('.dashboard-panel[data-panel-id]').forEach(panel => {
      panels[panel.dataset.panelId] = panel;
    });

    const container = this.querySelector('#dash-panels');
    if (!container) return;

    for (const id of order) {
      const panel = panels[id];
      if (panel && panel.parentNode === container) {
        container.appendChild(panel); // append in saved order
      }
    }
  }

  async refresh() {
    await Promise.all([
      this.renderStats(),
      this.renderActivity(),
      this.renderRecentThreats(),
      this.renderRecentImports(),
      this.renderGeoStats(),
      this.renderMostTargetedUsers(),
      this.renderTopFailedIps(),
      this.renderTopFailedAsns(),
    ]);
  }

  async renderStats() {
    const [logCount, threatCount, emailLogCount, imports, threats] = await Promise.all([
      countLogs(),
      countThreats(),
      countEmailLogs(),
      getAllImports(),
      getAllThreats(),
    ]);

    const criticalThreats = threats.filter(t => t.severity === 'critical').length;

    const stats = [
      {
        value: logCount,
        label: 'Total Log Entries',
        cssClass: 'stat-logs',
        icon: '<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>',
      },
      {
        value: threatCount,
        label: 'Total Threats',
        cssClass: 'stat-threats',
        icon: '<path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
      },
      {
        value: criticalThreats,
        label: 'Critical Threats',
        cssClass: 'stat-critical',
        icon: '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
      },
      {
        value: imports.length,
        label: 'Data Imports',
        cssClass: 'stat-imports',
        icon: '<path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>',
      },
      {
        value: emailLogCount,
        label: 'Email Logs',
        cssClass: 'stat-emails',
        icon: '<path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6z"/><path d="M22 6l-10 7L2 6"/>',
      },
    ];

    this.querySelector('#dash-stats').innerHTML = stats.map(s => `
      <div class="dashboard-stat-card ${s.cssClass}">
        <span class="stat-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${s.icon}</svg></span>
        <div class="stat-value">${s.value}</div>
        <div class="stat-label">${s.label}</div>
      </div>
    `).join('');
  }

  async renderActivity() {
    const logs = await getAllLogs();
    const container = this.querySelector('#dash-activity');

    if (logs.length === 0) {
      container.innerHTML = '';
      return;
    }

    const now = new Date();
    const dayBuckets = {};
    for (let i = ACTIVITY_DAYS - 1; i >= 0; i--) {
      const d = new Date(now);
      d.setDate(d.getDate() - i);
      const key = d.toISOString().slice(0, 10);
      dayBuckets[key] = 0;
    }

    for (const log of logs) {
      if (!log.timestamp) continue;
      const key = new Date(log.timestamp).toISOString().slice(0, 10);
      if (dayBuckets[key] !== undefined) {
        dayBuckets[key]++;
      }
    }

    const values = Object.values(dayBuckets);
    const maxVal = Math.max(...values, 1);

    container.innerHTML = Object.entries(dayBuckets).map(([date, count]) => {
      const pct = Math.max((count / maxVal) * 100, 2);
      const label = new Date(date).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      return `<div class="activity-bar" style="height: ${pct}%" title="${label}: ${count} logins">
        <span class="bar-tooltip">${label}<br>${count} logins</span>
      </div>`;
    }).join('');
  }

  async renderRecentThreats() {
    const body = this.querySelector('#dash-threats-body');
    const threats = await getAllThreats();

    if (threats.length === 0) {
      body.innerHTML = `<div class="dashboard-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
        <div class="empty-title">No threats detected</div>
        <div class="empty-desc">Import sign-in logs to begin threat analysis</div>
      </div>`;
      return;
    }

    const sorted = threats
      .sort((a, b) => SEVERITY_SORT_ASC[a.severity] - SEVERITY_SORT_ASC[b.severity])
      .slice(0, 8);

    body.innerHTML = sorted.map(t => {
      const colors = { critical: 'var(--accent-red)', high: 'var(--accent-orange)', medium: 'var(--accent-yellow)', low: 'var(--accent-green)' };
      return `<div class="dashboard-threat-item" data-id="${t.id}">
        <div class="threat-severity" style="background:${colors[t.severity] || 'var(--text-muted)'}"></div>
        <div class="threat-info">
          <div class="threat-title">${html(t.type.replace(/_/g, ' '))} — ${html(t.ip)}</div>
          <div class="threat-meta">${html(t.user)} · ${t.timestamp ? new Date(t.timestamp).toLocaleString() : '-'}</div>
        </div>
        <span class="badge badge-severity-${t.severity} threat-badge">${t.severity}</span>
      </div>`;
    }).join('');

    body.querySelectorAll('.dashboard-threat-item').forEach(item => {
      item.addEventListener('click', () => {
        const id = Number(item.dataset.id);
        const threat = threats.find(t => t.id === id);
        if (threat) {
          document.dispatchEvent(new CustomEvent('threatscope:show-detail', {
            detail: { type: 'threat', threat },
          }));
        }
      });
    });
  }

  async renderRecentImports() {
    const body = this.querySelector('#dash-imports-body');
    const imports = await getAllImports();

    if (imports.length === 0) {
      body.innerHTML = `<div class="dashboard-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        <div class="empty-title">No imports yet</div>
        <div class="empty-desc">Upload CSV or JSON sign-in log files to get started</div>
      </div>`;
      return;
    }

    const recent = imports.slice(0, 5);

    body.innerHTML = recent.map(imp => `
      <div class="dashboard-import-item">
        <div class="threat-info">
          <div class="threat-title">${html(imp.filename)}</div>
          <div class="threat-meta">
            ${imp.recordCount} records · ${imp.threatCount} threats · ${new Date(imp.importedAt).toLocaleString()}
          </div>
        </div>
        <span class="badge badge-source-${imp.source}">${imp.source}</span>
      </div>
    `).join('');
  }

  async renderMostTargetedUsers() {
    const body = this.querySelector('#dash-users-body');
    const userStats = await getLoginStatsByUser(8);

    if (userStats.length === 0) {
      body.innerHTML = `<div class="dashboard-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        <div class="empty-title">No user data</div>
        <div class="empty-desc">Import sign-in logs to see user targeting metrics</div>
      </div>`;
      return;
    }

    const maxFailed = userStats[0].failed || 1;

    body.innerHTML = userStats.map(u => {
      const failPct = maxFailed > 0 ? (u.failed / maxFailed) * 100 : 0;
      return `<div class="dashboard-user-item">
        <div class="user-info">
          <div class="user-name">${html(u.user)}</div>
          <div class="user-stat-bar-bg">
            <div class="user-stat-bar user-stat-fail-bar" style="width:${failPct}%"></div>
          </div>
          <div class="user-meta">${u.total} total logins</div>
        </div>
        <div class="user-counts">
          <span class="user-count user-count-failed">${u.failed} failed</span>
          <span class="user-count user-count-success">${u.success} success</span>
        </div>
      </div>`;
    }).join('');
  }

  async renderTopFailedIps() {
    const body = this.querySelector('#dash-failed-ips-body');
    const ipStats = await getFailedLoginsByIp(50);

    if (ipStats.length === 0) {
      body.innerHTML = `<div class="dashboard-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="3"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>
        <div class="empty-title">No failed IPs</div>
        <div class="empty-desc">No failed sign-in attempts recorded</div>
      </div>`;
      return;
    }

    const maxFailed = ipStats[0].failed || 1;

    body.innerHTML = ipStats.map(s => {
      const pct = (s.failed / maxFailed) * 100;
      return `<div class="dashboard-ip-item">
        <div class="ip-info">
          <div class="ip-address">${html(s.ip)}</div>
          <div class="ip-stat-bar-bg">
            <div class="ip-stat-bar ip-stat-fail-bar" style="width:${pct}%"></div>
          </div>
        </div>
        <div class="ip-count">${s.failed}</div>
      </div>`;
    }).join('');
  }

  async renderTopFailedAsns() {
    const body = this.querySelector('#dash-failed-asns-body');
    const asnStats = await getFailedLoginsByAsn(50);

    if (asnStats.length === 0) {
      body.innerHTML = `<div class="dashboard-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
        <div class="empty-title">No ASN data</div>
        <div class="empty-desc">Enrich IPs with GeoIP to see ASN breakdown</div>
      </div>`;
      return;
    }

    const maxFailed = asnStats[0].failed || 1;

    body.innerHTML = asnStats.map(s => {
      const pct = (s.failed / maxFailed) * 100;
      const label = s.asnName && s.asnName !== 'Unknown'
        ? `${html(s.asnName)} (${html(s.asn)})`
        : html(s.asn);
      return `<div class="dashboard-asn-item">
        <div class="asn-info">
          <div class="asn-name">${label}</div>
          <div class="asn-stat-bar-bg">
            <div class="asn-stat-bar asn-stat-fail-bar" style="width:${pct}%"></div>
          </div>
        </div>
        <div class="asn-count">${s.failed}</div>
      </div>`;
    }).join('');
  }

  async renderGeoStats() {
    const body = this.querySelector('#dash-geo-body');
    const enrichments = await getAllIpEnrichments();

    if (enrichments.length === 0) {
      body.innerHTML = `<div class="dashboard-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
        <div class="empty-title">No geo data</div>
        <div class="empty-desc">Import logs to see geographic distribution</div>
      </div>`;
      return;
    }

    const countryCounts = {};
    let unknownCount = 0;
    for (const e of enrichments) {
      if (e.country && e.country !== 'Unknown' && e.country !== 'Private') {
        countryCounts[e.country] = (countryCounts[e.country] || 0) + 1;
      } else {
        unknownCount++;
      }
    }

    const countries = Object.keys(countryCounts).length;
    const total = enrichments.length;
    const top = Object.entries(countryCounts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);

    body.innerHTML = `
      <div class="geo-stat-row">
        <div class="geo-stat-item">
          <div class="stat-value" style="color:var(--accent-blue)">${countries}</div>
          <div class="stat-label" style="font-size:0.7rem">Countries</div>
        </div>
        <div class="geo-stat-item">
          <div class="stat-value" style="color:var(--accent-green)">${total - unknownCount}</div>
          <div class="stat-label" style="font-size:0.7rem">Geo-located IPs</div>
        </div>
        <div class="geo-stat-item">
          <div class="stat-value" style="color:var(--accent-red)">${unknownCount}</div>
          <div class="stat-label" style="font-size:0.7rem">Unknown IPs</div>
        </div>
      </div>
      ${top.length > 0 ? `
      <div style="margin-top:8px;font-size:0.7rem;color:var(--text-muted)">Top Countries</div>
      <div class="geo-top-list">
        ${top.map(([country, count]) => `
          <div class="geo-top-row">
            <span class="geo-top-name">${html(country)}</span>
            <div class="geo-top-bar-bg">
              <div class="geo-top-bar" style="width:${(count / top[0][1]) * 100}%"></div>
            </div>
            <span class="geo-top-count">${count}</span>
          </div>
        `).join('')}
      </div>` : ''}
    `;
  }

}

customElements.define('dashboard-pane', DashboardPane);
